<template>
  <div class="text-center text-lg font-bold">Usuários</div>
  <text-input v-model="search" class="mt-3 w-full" placeholder="pesquisar" />
  <div class="mt-5" v-if="admins.length">
    <div class="text-center font-bold">Administradores</div>
    <div class="cursor-pointer border-b p-2 text-sm hover:bg-gray-200" @click.prevent="startChat(item)" v-for="(item, index) in admins">{{ item.name }}</div>
  </div>
  <div class="mt-5" v-if="professionals.length">
    <div class="text-center font-bold">Profissionais</div>
    <div class="cursor-pointer border-b p-2 text-sm hover:bg-gray-200" @click.prevent="startChat(item)" v-for="(item, index) in professionals">{{ item.name }}</div>
  </div>
  <div class="mt-5" v-if="patients.length">
    <div class="text-center font-bold">Pacientes</div>
    <div class="cursor-pointer border-b p-2 text-sm hover:bg-gray-200" @click.prevent="startChat(item)" v-for="(item, index) in patients">{{ item.name }}</div>
  </div>
  <div class="mt-5" v-if="!admins.length && !professionals.length && !patients.length">
    Nenhum usuário encontrado
  </div>
</template>
<script>
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    TextInput,
  },
  props: {
    users: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      search: '',
    };
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  computed: {
    admins: function () {
      return this.users.filter((item) => item.role === 1 && (!this.search.length || item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0));
    },
    professionals: function () {
      return this.users.filter((item) => item.role === 2 && (!this.search.length || item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0));
    },
    patients: function () {
      return this.users.filter((item) => item.role === 3 && (!this.search.length || item.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0));
    }
  },
  methods: {
    startChat(item) {
      this.$parent.startRoom(item);
    }
  },
  mounted() {
    
  }
}
</script>